import { createContext } from 'react';
import { IncidentDetail } from '@/custom-types';

export type IncidentDetailContextProps = {
  incident: IncidentDetail | undefined,
  downloadedImages: File[],
  setIncident: (incident: IncidentDetail | undefined) => void
  setDownloadedImages: (images: File[]) => void,
}

export const IncidentDetailContext = createContext<IncidentDetailContextProps | null>(null)
